import React, { useContext } from 'react';
import { useQuery } from '@apollo/client';
import { getPath } from '@express-labs/raven-tools';
import { HeaderDynamicContext } from '../../../../contexts/HeaderDynamicData/HeaderDynamicData';
import getFromStorage from '../../../../helpers/storage/storage';
import { getMemberWallet, getOrderSummary } from '../../../../queries';
import MemberWalletHeader from './MemberWalletHeader';

function MemberWalletHeaderVM() {
  const { customer } = useContext(HeaderDynamicContext);
  const { emailAddress } = customer;
  const isLoyaltyMigrationEnabled = window.FLAGS?.LoyaltyMigration;
  const loyaltyWarmStateData = getFromStorage('loyaltyWarmStateData', {});
  const loyaltyId = loyaltyWarmStateData.loyaltyNumber || '';
  const userId = isLoyaltyMigrationEnabled ? emailAddress : loyaltyId;
  const { loading, error, data } = useQuery(getMemberWallet, {
    variables: { loyaltyId: userId },
  });
  const { data: orderSummary } = useQuery(getOrderSummary, {
    variables: {
      shouldRecalculateTax: false,
    },
  });
  const walletCouponCode = getPath(
    orderSummary,
    'orderSummary.promotions.0.walletCouponCode',
    null,
  );
  const couponCode = getPath(
    orderSummary,
    'orderSummary.promotions.0.code',
    null,
  );
  const appliedCode = walletCouponCode || couponCode;

  return (
    <MemberWalletHeader
      appliedCode={appliedCode}
      loading={loading}
      error={error}
      data={data}
    />
  );
}

export default MemberWalletHeaderVM;
